import {getAccountsCrmModules} from 'src/openapi/admin/apis/CrmModuleSettingsControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import {COLUMNS} from '../../../constants';

type Props = {
    data: Record<string, string>[],
    selectedColumns: string[],
    accountIds: number[],
    nameToIdsMap: Record<string, number>,
    apiDispatch: ReturnType<typeof useAppDispatch>,
};

export const fetchCrmIntegrations = async (props: Props): Promise<Record<string, string>[] | null> => {
    const {data, selectedColumns, accountIds, nameToIdsMap, apiDispatch} = props;

    const relevantColumns = [
        COLUMNS.SALESFORCE_INTEGRATION,
        COLUMNS.MS_DYNAMICS_INTEGRATION,
        COLUMNS.DEAL_CLOUD_INTEGRATION,
        COLUMNS.HUBSPOT_INTEGRATION,
    ];

    const neededColumns = relevantColumns.filter(column => selectedColumns.includes(column));
    if (neededColumns.length === 0) {
        return data;
    }

    const response = await apiDispatch(getAccountsCrmModules({requestBody: accountIds}));
    if (!response.payload.success) {
        return null;
    }

    const crmIntegration = response.payload.data;

    return data.map(row => {
        const accountId = nameToIdsMap[row[COLUMNS.ACCOUNT_NAME]];
        const crm = crmIntegration[accountId];

        return {
            ...row,
            ...(selectedColumns.includes(COLUMNS.SALESFORCE_INTEGRATION) && {
                [COLUMNS.SALESFORCE_INTEGRATION]: crm?.sfdcEnabled ? 'Yes' : 'No',
            }),
            ...(selectedColumns.includes(COLUMNS.MS_DYNAMICS_INTEGRATION) && {
                [COLUMNS.MS_DYNAMICS_INTEGRATION]: crm?.msdEnabled ? 'Yes' : 'No',
            }),
            ...(selectedColumns.includes(COLUMNS.DEAL_CLOUD_INTEGRATION) && {
                [COLUMNS.DEAL_CLOUD_INTEGRATION]: crm?.dealCloudEnabled ? 'Yes' : 'No',
            }),
            ...(selectedColumns.includes(COLUMNS.HUBSPOT_INTEGRATION) && {
                [COLUMNS.HUBSPOT_INTEGRATION]: crm?.hubspotEnabled ? 'Yes' : 'No',
            }),
        };
    });
};
